import { render, staticRenderFns } from "./BuildingModal.vue?vue&type=template&id=77bb608c&scoped=true&"
import script from "./BuildingModal.vue?vue&type=script&lang=js&"
export * from "./BuildingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb608c",
  null
  
)

export default component.exports